import { cn } from '../../../../utils';
import CustomImage from '../CustomImage/CustomImage';
import Initial from '../Initial/Initial';

const Avatar = ({
  userName,
  imagePath,
  height = 'h-[28px]',
  width = 'w-[28px]',
  initialTextSize,
  initialClassName,
  className,
}) => {
  if (userName === 'Unknown User') {
    return (
      <div className={cn('rounded-full', className, height, width)}>
        <CustomImage
          src={imagePath ? imagePath : '/assets/unknown-user.png'}
          unoptimized={
            process.env.NEXT_PUBLIC_BACKEND_URL === 'http://localhost:8000'
              ? true
              : false
          } //writing this solves the image not showing problem in localhost
          alt='Avatar img'
          // height={extractNumericValue(height)}
          // width={extractNumericValue(width)}
          height={height}
          width={width}
          sizes='81px'
          className={cn('rounded-full', className)}
        />
      </div>
    );
  } 
  else if (imagePath) {
    return (
      <CustomImage
        src={imagePath}
        unoptimized={
          process.env.NEXT_PUBLIC_BACKEND_URL === 'http://localhost:8000'
            ? true
            : false
        }
        alt='Avatar img'
        height={height}
        width={width}
        sizes='81px'
        className={cn('rounded-full', className, height, width)}
      />
    );
  } else if (userName) {
    return (
      <Initial
        label={userName}
        height={height}
        width={width}
        initialTextSize={initialTextSize}
        className={initialClassName}
      />
    );
  } else {
    return (
      <Initial
        label='U'
        height={height}
        width={width}
        initialTextSize={initialTextSize}
        className={initialClassName}
      />
    );
  }
};

export default Avatar;
